module.exports = __webpack_public_path__ + "static/media/logo_sair.a64322ac.png";